<template>
    <v-card  max-width="100%" width="100%">
      <v-toolbar color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('stats.resume')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="resumeData"
          item-key="_id"
          class="nowrap"
          hide-default-footer
        ></v-data-table>
      </v-card-text>
    </v-card>
</template>
<script>
export default {
  name: "Resume",
  components: {},
  data() {
    return {
      search: "",
      headers: [
        {
          text: this.$t('debrief.resume.level'),
          align: 'center',
          value: 'level'
        },
        {
          text: this.$t('debrief.resume.name'),
          align: 'center',
          value: 'name'
        },
        {
          text: this.$t('debrief.resume.averageRequestQuantity'),
          align: 'center',
          value: 'averageRequestQuantity'
        },
        {
          text: this.$t('debrief.resume.averageOrderQuantity'),
          align: 'center',
          value: 'averageOrderQuantity'
        },
        {
          text: this.$t('debrief.resume.range'),
          align: 'center',
          value: 'range'
        },
        {
          text: this.$t('debrief.resume.otd'),
          align: 'center',
          value: 'otd'
        },
        {
          text: this.$t('debrief.resume.delaysDepth'),
          align: 'center',
          value: 'delaysDepth'
        },
        {
          text: this.$t('debrief.resume.averageStock'),
          align: 'center',
          value: 'averageStock'
        },
        {
          text: this.$t('debrief.resume.stockCost'),
          align: 'center',
          value: 'stockCost'
        },
        {
          text: this.$t('debrief.resume.delayCost'),
          align: 'center',
          value: 'delayCost'
        },
        {
          text: this.$t('debrief.resume.cost'),
          align: 'center',
          value: 'cost'
        }
      ]
    };
  },
  mounted() {},
  methods: {
    customToFixed (val) {
      if ((val % 1) != 0) {
        return val.toFixed(1)
      } else {
        return val
      }
    }
  },
  computed: {
    resumeData () {
      return this.$store.state.game.data ? this.$store.state.game.data.companies.map((company) => { 
        if (company.assignable) {
          return {
            level: company.level,
            name: company.name,
            averageRequestQuantity: this.customToFixed(company.data.resume.averageRequestQuantity),
            averageOrderQuantity: this.customToFixed(company.data.resume.averageOrderQuantity),
            range: this.customToFixed(company.data.resume.range),
            otd: this.customToFixed(company.data.resume.otd * 100) + '%',
            delaysDepth: this.customToFixed(company.data.resume.delaysDepth),
            averageStock: this.customToFixed(company.data.resume.averageStock),
            stockCost: this.customToFixed(company.data.resume.stockCost),
            delayCost: this.customToFixed(company.data.resume.delayCost),
            cost: this.customToFixed(company.data.resume.cost)
          }
        } else {
          return {
              level: company.level,
              name: company.name,
              averageOrderQuantity: this.customToFixed(company.data.resume.averageOrderQuantity),
              range: company.data.resume.range,
              otd: "",
              delaysDepth: "",
              averageStock: "",
              stockCost: "",
              delayCost: "",
              cost: ""
            }
        }
      }) : [] 
    }
  }
};
</script>
<style>
.nowrap td{
  white-space: nowrap !important;
}
</style>